import Request from 'src/utils/request'

/**
 * 获取企业微信的JS配置信息
 * @param {Object} data 请求所需参数
 * @param {string} data.url url
 * @returns {Promise<unknow>}
 */
export function postWxWorkJsConfigApi (data) {
  return Request({
    url: '/follow/wx/work/js/config',
    method: 'post',
    data
  })
}

/**
 * 获取企业微信的应用JS配置信息
 * @param {Object} data 请求所需参数
 * @param {number} data.agentId 应用ID
 * @param {string} data.url url
 * @returns {Promise<unknow>}
 */
export function postWxWorkAgentJsConfigApi (data) {
  return Request({
    url: '/follow/wx/work/agent/js/config',
    method: 'post',
    data
  })
}

/**
 * 操作人企业微信登录
 * @param {Object} data 请求所需参数
 * @param {string} data.code 企业微信授权code
 * @returns {Promise<string>}
 */
export function postOperatorWxWorkLoginApi (data) {
  return Request({
    url: '/follow/wx/work/login',
    method: 'post',
    data
  })
}
export function postOperatorWxWorkLoginOldApi (data) {
  return Request({
    url: '/api/operator/login',
    method: 'post',
    data
  })
}
/**
 * @typedef GetOperatorInfoApiResponse 获取操作人信息Api返回值
 * @property {number} associationType 数据权限关联类型 0 无 1 分组（组长） 2 医生
 * @property {boolean} isMedicineDepartmentAuthority 是否医学部权限
 * @property {{ id: number, menuName: string, menuWeight: number, subMenuList: { id: number, menuName: string, menuUrl: string, menuWeight: number }[] }[]} menuList 菜单列表
 * @property {number} operatorId 操作人ID
 * @property {string} operatorName 操作人姓名
 * @property {string} operatorPhone 操作人手机号
 * @property {string} token 令牌
 */

/**
 * 获取操作人信息
 * @returns {Promise<GetOperatorInfoApiResponse>}
*/
export function getOperatorInfoApi () {
  return Request({
    url: '/follow/user/info',
    method: 'get'
  })
}

export function getWxWorkUserInfoOldApi (externalUserId) {
  return Request({
    url: `/follow-up/wx/work/${externalUserId}/user/info`,
    method: 'get'
  })
}

export function getWxWorkPatientInfoOldApi (patientId, params) {
  return Request({
    url: `/follow-up/api/v1/wx/work/${patientId}/patient/info`,
    method: 'get',
    params
  })
}
